// Sorting, range and URL helpers shared by the feature-level filters.js files
// (recipes, ingredients). Feature files keep their own column options and value
// getters; everything generic lives here.

// Reads a "min-max" search param back into a [min, max] tuple, or null when the
// param is absent or malformed.
export function parseRangeParam(param) {
  if (!param) return null;
  const [min, max] = param.split('-').map(Number);
  if (Number.isNaN(min) || Number.isNaN(max)) return null;
  return [min, max];
}

// Reads the ?sort= and ?dir= params, falling back to the feature's defaults when
// they are missing or not one of the allowed columns.
export function parseSortParams(searchParams, columnOptions, defaults) {
  const sortParam = searchParams.get('sort');
  const dirParam = searchParams.get('dir');

  return {
    column: columnOptions.some((option) => option.value === sortParam) ? sortParam : defaults.column,
    direction: dirParam === 'asc' || dirParam === 'desc' ? dirParam : defaults.direction,
  };
}

// Sorts a copy of items by the getter registered for sort.column, falling back
// to defaultColumn when the column is unset or unknown. Extra arguments are
// passed through to the getter, which is how the ingredient getters receive
// their category lookups.
export function sortItems(items, sort, valueGetters, defaultColumn, ...getterArgs) {
  const getValue = valueGetters[sort.column] || valueGetters[defaultColumn];
  const dir = sort.direction === 'asc' ? 1 : -1;

  return [...items].sort((a, b) => {
    const valueA = getValue(a, ...getterArgs);
    const valueB = getValue(b, ...getterArgs);
    if (valueA < valueB) return -dir;
    if (valueA > valueB) return dir;
    return 0;
  });
}

const EMPTY_RANGE = [0, 0];

// Widest [min, max] covering the given values, rounded outwards so a slider can
// always reach every value. Nullish entries are ignored; no values at all gives
// an empty range.
export function rangeBounds(values) {
  const present = values.filter((value) => value != null);
  if (present.length === 0) return EMPTY_RANGE;
  return [Math.floor(Math.min(...present)), Math.ceil(Math.max(...present))];
}
